
import { NotifyHelper } from "../../../helpers/toast";
import { eKeHoachMonNVActionsObj } from "../../action-types/ke-hoach/IKeHoachMonNVActions";

import { generateActionForKey, generateActions } from "../generateActions";

export const keHoachMonNVActions = {
  ...generateActions(eKeHoachMonNVActionsObj, "KE_HOACH_MON_NV"),
  ...generateActionForKey(eKeHoachMonNVActionsObj, "KE_HOACH_MON_NV",
    "UPDATE_KHM_SUCCESS", () => {
      NotifyHelper.Success("Thành công")
    }),
};
